import { LOINC_CODE_SYSTEM, SNOMED_CT_SYSTEM } from '#src/codeSystems.ts'
import { ASSESSMENT_ANSWER_CODES } from '#src/terminology/answerCodes.ts'
import { ASSESSMENT_QUESTION_CODES } from '#src/terminology/questionCodes.ts'

const KNOWN_SYSTEM_NAMES: ReadonlyMap<string, string> = new Map([
  [LOINC_CODE_SYSTEM, 'LOINC'],
  [SNOMED_CT_SYSTEM, 'SNOMED CT'],
  ...[ASSESSMENT_QUESTION_CODES, ASSESSMENT_ANSWER_CODES].flatMap(
    (system): [string, string][] =>
      system.url && system.title ? [[system.url, system.title]] : []
  ),
])

// What a code system is called: its title for our own and a well-known
// name for LOINC and SNOMED CT, else the last part of its URL, worded.
export function codeSystemName(url: string): string {
  const known = KNOWN_SYSTEM_NAMES.get(url)
  if (known) {
    return known
  }
  const last = url.split(/[/#]/).filter(Boolean).at(-1) ?? url
  const words = last.replaceAll(/[-_]+/g, ' ')
  return words.charAt(0).toUpperCase() + words.slice(1)
}
